import { render, staticRenderFns } from "./AHMOPI.vue?vue&type=template&id=2278bd4a&scoped=true"
import script from "./AHMOPI.vue?vue&type=script&lang=js"
export * from "./AHMOPI.vue?vue&type=script&lang=js"
import style0 from "./AHMOPI.vue?vue&type=style&index=0&id=2278bd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278bd4a",
  null
  
)

export default component.exports